<div class="container-fluid px-3 py-3">
  <div class="row align-items-center mb-4">
    <div class="col-md-6">
      <h2 class="text-danger fw-bold mb-0">{{ section.title }}</h2>
    </div>
    <div class="col-md-6">
      <div class="d-flex justify-content-end gap-3 flex-wrap">
        <p-button [label]="data.tabTitle"
                  styleClass="p-button-text category-tab active-tab text-danger"
                  [text]="true"
                  *ngFor="let data of section.sectionData; let index = index"
                  (onClick)="changeIndex(index)"
        ></p-button>
      </div>
    </div>
  </div>

  <app-images [data]="section.sectionData[selectedIndex]"></app-images>
<p class="py-2"></p>
  <p-carousel [value]="relatedProducts"
              [numVisible]="5"
              [numScroll]="1"
              [responsiveOptions]="responsiveOptions"
              *ngIf="relatedProducts?.length"
              [circular]="true">
    <ng-template let-relatedProducts pTemplate="item">
      <app-product [product]="relatedProducts"></app-product>
    </ng-template>
  </p-carousel>
</div>
